/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isJSSlot(data) {
  return data && data.type === 'JSSlot';
}